// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__GyIvl","text":"tooltip_text__8pgiB"};